/* projects/speaker-platform/src/app/atoms/action-button/action-button.component.scss */
.actionbutton {
  display: inline-flex;
  align-items: center;
  padding: 14px 10px;
  color: #505050;
  border: 0;
  border-radius: 10px;
  background-color: #fff;
  max-width: 175px;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1607843137);
}
.actionbutton:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.actionbutton__icon {
  font-size: 35px;
}
.actionbutton__label {
  padding: 0 13px;
  font-size: 14px;
}
.actionbutton--disabled {
  opacity: 0.1;
}
/*# sourceMappingURL=action-button.component-I3QKSAO6.css.map */
